import { Fragment } from "react";

// Currency formatter for goal statements, drops the ".00" on whole-dollar
// amounts so goals read like "$4100/month" and "$6000" instead of
// "$4100.00/month" and "$6000.00". Keeps cents when they matter, e.g.
// "$1192.25 every week".
export const formatGoalCurrency = (num) => {
  const n = Number(num);
  if (!Number.isFinite(n)) return "$0";
  const isWhole = Math.round(n * 100) % 100 === 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: isWhole ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(n);
};

// "a", "a and b", "a, b, and c"
export const joinAnd = (xs) => {
  if (xs.length <= 1) return xs[0] || "";
  if (xs.length === 2) return `${xs[0]} and ${xs[1]}`;
  return `${xs.slice(0, -1).join(", ")}, and ${xs[xs.length - 1]}`;
};

const IN_YEAR = / in 1 year$/;
const OFF_YEAR = / off this year$/;

// Collapse every 12-month goal into one "… this year" clause so the sentence
// never says "in one year … this year … this year".
export const mergeYearGoals = (parts) => {
  const year = [];
  const rest = [];
  parts.forEach((p) => {
    if (IN_YEAR.test(p) || OFF_YEAR.test(p)) year.push(p.replace(IN_YEAR, "").replace(OFF_YEAR, " off"));
    else rest.push(p);
  });
  if (year.length === 0) return parts;
  return [...rest, `${joinAnd(year)} this year`];
};

// Same idea for JSX: items = [{ key, node, year }]. Year nodes must NOT include their own timeframe.
export const mergeYearGoalNodes = (items) => {
  const year = items.filter((i) => i.year);
  const rest = items.filter((i) => !i.year).map((i) => <Fragment key={i.key}>{i.node}</Fragment>);
  if (year.length === 0) return rest;
  const sep = (idx) => {
    if (idx === 0) return null;
    if (year.length === 2) return " and ";
    return idx === year.length - 1 ? ", and " : ", ";
  };
  return [
    ...rest,
    <Fragment key="year-goals">
      {year.map((i, idx) => <Fragment key={i.key}>{sep(idx)}{i.node}</Fragment>)} this year
    </Fragment>,
  ];
};
